import { render, staticRenderFns } from "./BookingStudentIndex.vue?vue&type=template&id=4308ab06&"
import script from "./BookingStudentIndex.vue?vue&type=script&lang=js&"
export * from "./BookingStudentIndex.vue?vue&type=script&lang=js&"
import style0 from "./BookingStudentIndex.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports